import { style } from '@vanilla-extract/css';
import {
  borderWidthVars,
  radiusVars,
  spacingVars,
} from '@tundr/ds-foundations';
import { semanticTokenVars, shadowVars } from '@tundr/ds-tokens';

const DROPDOWN_MIN_WIDTH_PX = 200;
const DROPDOWN_MAX_WIDTH_PX = 380;
const DROPDOWN_HEIGHT_PX = 320;
const DROPDOWN_MAX_HEIGHT_PX = 400;
const DROPDOWN_MAX_HEIGHT = `min(60vh, ${DROPDOWN_MAX_HEIGHT_PX}px)`;
const DROPDOWN_Z_INDEX = 9999;

export const dropdownContentClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: spacingVars.xs,
  minWidth: DROPDOWN_MIN_WIDTH_PX,
  maxWidth: DROPDOWN_MAX_WIDTH_PX,
  height: 'auto',
  maxHeight: DROPDOWN_MAX_HEIGHT,
  overflowY: 'auto',
  backgroundColor: semanticTokenVars.surface.background.neutral.default.base,
  border: `${borderWidthVars.xs} solid ${semanticTokenVars.border.neutral.default.subtle}`,
  borderRadius: radiusVars.md,
  boxShadow: shadowVars.md,
  outline: 'none',
  position: 'relative',
});

export const dropdownContentSelfScrollClass = style({
  overflow: 'hidden',
});

export const dropdownContentSameWidthClass = style({
  minWidth: 'unset',
  maxWidth: 'unset',
});

export const dropdownContentPaddingClass = style({ padding: spacingVars.sm });

/** Forces a fixed content height (`fixedHeight`). */
export const dropdownContentFixedHeightClass = style({
  height: DROPDOWN_HEIGHT_PX,
  maxHeight: DROPDOWN_HEIGHT_PX,
});

/** z-index for the teleported Ark popover positioner. */
export const dropdownPositionerClass = style({
  zIndex: DROPDOWN_Z_INDEX,
});

/** Removes the default focus outline on the Ark popover content wrapper. */
export const dropdownContentResetClass = style({
  outline: 'none',
});

/** Horizontal separator between sections of a dropdown panel. */
export const dropdownPanelDividerClass = style({
  height: borderWidthVars.xs,
  flexShrink: 0,
  backgroundColor: semanticTokenVars.border.neutral.default.subtle,
  margin: spacingVars.sm,
});

/** Stretches the `#trigger` slot to full width (`triggerFullWidth`). */
export const slotTriggerFullWidthClass = style({
  width: '100%',
});

export const dropdownIconTriggerClass = style({
  alignSelf: 'center',
});

/**
 * Reset default button styles for this Dropdown's Ark UI Popover trigger.
 * Applied as a class directly on the trigger so it does NOT leak to other Ark
 * Popover triggers in the app (previously a global `[data-scope="popover"]` rule).
 */
export const dropdownTriggerResetClass = style({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
});
